import React, { useEffect, useState } from "react";
import './TableNfe.css';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Button, Col, Collapse, Input, Modal, Spinner } from "reactstrap";
import NumberFormat from "react-number-format";
import ModalLote from "./ModalLote";

const TableNfe = ({ columns, data, readOnly, checkAll, recalculaMargemMkp, setColumn, gravaPosicaoColunas, config, rowStyle, onBlurQtde, movimentacao, listarMovimentacao, onTableChange }) => {

  const colunasLotes = [
    {
      titulo: 'Lote',
      width: '100px',
      align: 'center',
      dataField: 'nLote'
    }, {
      titulo: 'Qtde',
      width: '80px',
      align: 'center',
      dataField: 'qLote'
    }, {
      titulo: 'Fabricação',
      width: '100px',
      align: 'center',
      dataField: 'dFab'
    }, {
      titulo: 'Validade',
      width: '100px',
      align: 'center',
      dataField: 'dVal'
    }
  ]

  const initialLote = {
    nLote: { _text: '' },
    qLote: { _text: '' },
    dFab: { _text: '' },
    dVal: { _text: '' }
  }

  const [form, setForm] = useState(data);
  const [isOpenModalLote, setIsOpenModalLote] = useState(false);
  const [lote, setLote] = useState(initialLote);
  const [idxProd, setIdxProd] = useState('');
  const [idxLote, setIdxLote] = useState(-1);
  const [colInEdit, setColInEdit] = useState(-1);
  const [rowInEdit, setRowInEdit] = useState(-1);

  useEffect(() => {
    setForm(data);
  }, [data])

  const countSubstr = (string, subString, allowOverlapping) => {
    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  }


  const getClassName = (linha, tipo, col) => {

    let className = ' ';

    if (tipo == 'linha') {

    }

    if (tipo == 'coluna') {
      if (linha.det.prod.prod_ativo._text === 'N') {
        // className = ' legend-item pr-matriz-maior';
      }
      if (col.dataField == 'prVendaCorrigido') {
        if (linha.det.prod.prVendaCorrigido._text < linha.det.prod.preco_matriz._text) {
          className = ' legend-item pr-matriz-maior';
        }
      }
      if (linha.det.prod.prVendaCorrigido._text > linha.det.prod.preco_matriz._text) {
        // className = ' legend-item pr-matriz-menor';
      }
    }



    return className;
  }

  const onChangeInput = (e, idx) => {
    let frm = [...form];

    let value = e.target.value;

    columns.map(col => {
      if (col.dataField == e.target.name) {
        value = value.replace(',', '.');

        if (value.includes('.')) {
          if (countSubstr(value, '.') > 1) {
            value = (value.replace(/[^0-9]/g, '') / 100);
          } else {
            value = value.replace(/[^0-9.]/g, '');
          }
        } else {
          value = value.replace(/[^0-9]/g, '');
        }

        // value = Number(value).toFixed(2);
        // if(col.currency){
        //   value = value.replace('R$ ',''); 
        //   value = value.replace(',','.');
        //   value = /[0-9,.]/
        // }

        // if(col.sufix !== ""){
        //   value = value.replace(col.sufix,'');
        //   value = value.replace(',','.');
        // }
      }
    })

    frm[idx][e.target.name] = value;

    setForm(frm);

    if (recalculaMargemMkp) recalculaMargemMkp();
  }

  const onChangeCB = (e, idx) => {
    let frm = [...form]

    let checked = e.target.checked;

    frm[idx].checked = checked;

    setForm(frm);
  }

  const onChangeCheckAll = (e) => {
    checkAll(e.target.checked);
    // let frm = [...form] 

    // frm.map(linha=>{
    //   linha.checked = e.target.checked
    // })

    // setForm(frm);
  }

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: 8,
    width: 250
  });

  const onDragEnd = (e) => {
    // console.log(e)
    if (e.destination != null) {
      let origIdx = e.source.index;
      let destIdx = e.destination.index;

      let newCol = [];

      let oldSource = columns[origIdx];
      let oldDest = columns[destIdx];

      columns.map((col, i) => {
        if (i != origIdx) {
          newCol.push(col)
        }
        // if(i == destIdx){
        //   newCol.push(oldSource);
        //   console.log(destIdx)
        //   // newCol.push(oldDest)
        //  }else 
        // if(i == positon){
        //   newCol.push(oldDest);
        //   console.log(positon)
        // }else if((origIdx < destIdx )&&(i != positon)){
        //   newCol.push(col)
        // }else{
        //   newCol.push(col)
        // }
        // console.log(col)
      })
      newCol.splice(destIdx, 0, oldSource);
      gravaPosicaoColunas(newCol);
      setColumn(newCol);
    }
  }

  // const linhaCollapse = (linha) => {
  //   linha['lojas'].map((loja, idxLoja) =>
  //     //  return (
  //     <div
  //       key={`col-filial-${idxLoja}`}
  //       // className={[styles.columnCell,styles.rowColor]}
  //       className={'column-cell'}
  //       style={{ width: col.width, textAlign: col.align }}
  //     >{loja[idxLoja]}
  //     </div>
  //     // )
  //   )
  // }

  const CabecalhoLotes = ({ idx }) => {
    return (
      <>
        {colunasLotes.map((coluna) =>
          <div
            key={`col-header${coluna.titulo}`}
          >
            <div style={{ width: coluna.width, textAlign: coluna.align }} className={'lotes-header-column-cell'}>
              {coluna.titulo}
            </div>
          </div>
        )}
        <div
          className="d-flex justify-content-center"
          style={{ width: '40px', cursor: 'pointer' }}
          onClick={() => { novoLote(idx) }}
        >
          <i className={"fas fa-plus lotes-icon"}></i>
        </div>
      </>
    )
  }

  const ChangeCollapse = (idx) => {
    let frm = [...form];

    frm.map(linha => {
      if (linha.idx == idx) {
        linha.det.prod.collapse_lote = !linha.det.prod.collapse_lote;
      }
    })

    setForm(frm);
  }

  const LinhaLote = ({ linha, idxLote, idxProd }) => {

    return (
      <div
        key={`row-grupo-detalhes-${idxLote}`}
        className={'row-grupo lotes-row-grupo row-data-grid ' + ((idxLote % 2 == 0) ? '' : 'lotes-row-color')}
      >
        <div
          key={`row-${idxLote}`}
          style={{ display: 'flex' }}
        >

          {colunasLotes.map((coluna, idxCol) =>
            <div
              key={`col-det-${idxCol}`}
              className={'column-cell'}
              style={{ width: coluna.width, textAlign: coluna.align }}
            >
              <span className={'prod-name'} style={{ width: coluna.width }}>{linha[coluna.dataField]._text}</span>
            </div>
          )
          }

          <div
            className="prod-name d-flex justify-content-center"
            style={{ width: '40px', cursor: 'pointer' }}
            onClick={() => { setLote(linha); setIdxLote(idxLote); setIdxProd(idxProd); setIsOpenModalLote(true) }}
          >
            <i className={"fa fa-pencil lotes-icon"}></i>
          </div>

        </div>


      </div>)
  }

  const onCloseModalLote = () => {
    setIsOpenModalLote(false);
  }

  const novoLote = (idx) => {
    // let frm = [...form];

    // frm.map(linha => {
    //   if (linha.idx == idx) {
    //     if(Array.isArray(linha.det.prod.rastro)){
    //       linha.det.prod.rastro.push(initialLote);        
    //     }else{
    //       let aLote = [];

    //       aLote.push(linha.det.prod.rastro);
    //       aLote.push(initialLote);

    //       linha.det.prod.rastro = aLote;
    //     }
    //   }
    // })

    // console.log(frm)

    setIdxProd(idx);
    setIdxLote(-1);
    // setForm(frm);

    setLote(initialLote);
    setIsOpenModalLote(true);
  }

  const onChangeCampo = (e, linha) => {
    const dtField = e.target.name;
    const nValue = e.target.value;
    const type = 'edit';
    const rowId = linha.idx;

    onTableChange(type, data = form, rowId, dtField, nValue);
    setColInEdit(-1);
    setRowInEdit(-1);
  }

  const onDblClick = (e, colIdx, rowIdx, linha) => {
    if ((e.detail == 2) && (columns[colIdx].editable)) {
      if (columns[colIdx].disabled && columns[colIdx].disabled(linha)) return;
      setColInEdit(colIdx);
      setRowInEdit(rowIdx);
    }
  }

  const Cell = ({ colIdx, rowIdx, col, linha, type }) => {
    if (type == 'currency') {
      return (
        <div
          key={`col-${colIdx}`}
          // className={[styles.columnCell,styles.rowColor]}
          className={'column-cell long-name'}
          style={{ width: col.width, textAlign: col.align }}
        >
          <NumberFormat
            required
            name={columns[colIdx].dataField}
            placeholder=""
            defaultValue={(() => {
              if (col.editValue) return parseFloat(col.editValue(linha)) || 0;
              const raw = (columns[colIdx].formatter('', linha) + '');
              if (raw.includes('R$')) return parseFloat(raw.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
              return parseFloat(raw) || 0;
            })()}
            onBlur={(e) => { onChangeCampo(e, linha) }}
            onKeyDown={(e) => { if (e.key === 'Enter') onChangeCampo(e, linha) }}
            style={{ width: col.width, textAlign: col.align, fontSize: '12px' }}
            decimalScale={2}
            allowNegative={false}
            className={"form-control"}
            decimalSeparator={','}
            fixedDecimalScale
          />
        </div>
      );
    }

    if (type == 'readOnly') {
      return (
        <div
          key={`col-${colIdx}`}
          // className={[styles.columnCell,styles.rowColor]}
          className={'column-cell long-name' + getClassName(linha, 'coluna', col.dataField)}
          //style={{ width: col.width, textAlign: col.align }}
          style={columns[colIdx].style ? { ...columns[colIdx].style('', linha), width: col.width, textAlign: col.align } : { width: col.width, textAlign: col.align }}
          onClick={(e) => { onDblClick(e, colIdx, linha.idx, linha) }}
          title={col.tooltip ? col.tooltip(linha) : undefined}
        >
          {col.checkbox && <input type="checkbox" onChange={(evt) => { onChangeCB(evt, rowIdx) }} checked={linha.checked}></input>}
          {/* {col.currency && `R$ ${linha[columns[colIdx].formatter('',linha)]}`} */}
          {col.sufix && `${linha[columns[colIdx].dataField]} ${col.sufix}`}
          {/* {linha[columns[colIdx].dataField].formatter('',linha)} */}
          {!col.sufix && columns[colIdx].formatter('', linha)}
        </div>
      )
    }

    if (type == 'edit') {
      return (
        <div
          key={`col-${colIdx}`}
          // className={[styles.columnCell,styles.rowColor]}
          className={'column-cell long-name'}
          //style={{ width: col.width, textAlign: col.align }}
          style={columns[colIdx].style ? { ...columns[colIdx].style('', linha), width: col.width, textAlign: col.align } : { width: col.width, textAlign: col.align }}
          onClick={(e) => { onDblClick(e, colIdx, linha.idx, linha) }}
        >
          <Input
            name={col.dataField}
            defaultValue={col.editValue ? col.editValue(linha) : columns[colIdx].formatter('', linha)}
            style={columns[colIdx].style ? { ...columns[colIdx].style('', linha), width: col.width, textAlign: col.align, fontSize: '10px' } : { width: col.width, textAlign: col.align, fontSize: '10px' }}
            onBlur={(e) => { onChangeCampo(e, linha) }}
            onKeyDown={(e) => { if (e.key === 'Enter') onChangeCampo(e, linha) }}
          />
        </div>
      )
    }
  }

  return (
    <div className="container-table">
        <Modal size='lg' isOpen={isOpenModalLote}>
          <ModalLote
            lote={lote}
            setForm={setForm}
            onclose={onCloseModalLote}
            data={form}
            idx={idxProd}
            idxLote={idxLote}
          ></ModalLote>
        </Modal>
        <div className="table-cabecalho">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable
              droppableId="droppable"
              direction="horizontal"
            >
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  // style={getListStyle(provided.isDraggingOver)}              
                  // {...provided.droppableProps}
                  // {...provided.placeholder}
                  // {...provided}
                  className={'header-row'}
                >
                  {/* <div > */}

                  <div
                    key={`col-header-000000000000`}
                  // className={'header-column-cell'}
                  // style={{width:coluna.width, textAlign: coluna.align}}                          
                  >
                    <div style={{ width: '50px', textAlign: 'center' }} className={'header-column-cell'}>
                      {'Lotes'}
                    </div>
                  </div>

                  {columns && columns.map((coluna, idx) =>


                    <Draggable key={`drag-key-${idx}`} draggableId={`${idx}`} index={idx}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          key={`col-header-${coluna.dataField}`}
                        // className={'header-column-cell'}
                        // style={{width:coluna.width, textAlign: coluna.align}}                          
                        >
                          <div style={{ width: coluna.width, textAlign: coluna.align }} className={'header-column-cell'}>
                            {/* {coluna.checkbox &&
                              <input
                                type="checkbox"
                                onChange={onChangeCheckAll}
                              ></input>
                            } */}
                            {coluna.text}
                          </div>
                        </div>
                      )}
                    </Draggable>



                  )}
                  {/* </div> */}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        <div className="table-body">

          {form && form.map((linha, idx) =>

            <div key={`row-grupo-${idx}`}>
              <div
                style={{ display: 'flex', ...(rowStyle ? rowStyle(linha, idx) : {}) }}
                className={getClassName(linha, 'linha') + (idx % 2 !== 0 ? ' row-color' : '')}
              >
                <div
                  className={'column-cell edit-dtable'}
                  style={{ width: '50px', textAlign: 'center' }}
                >
                  <i
                    className={"icon-filtro " + (linha.det.prod.collapse_lote == true ? "fa fa-minus-circle" : "fa fa-plus-circle") + " icon-plus"}
                    onClick={() => { ChangeCollapse(linha.idx) }}
                  >{' '}</i>
                </div>
                {columns.map((col, colIdx) =>
                  <React.Fragment key={`col-frag-${colIdx}`}>
                    {col.editable && !readOnly && colInEdit == colIdx && rowInEdit == linha.idx && col.currency &&
                      <Cell colIdx={colIdx} rowIdx={idx} col={col} linha={linha} type='currency' />}
                    {(!col.editable || readOnly || (col.editable && rowInEdit != linha.idx) || (col.editable && colIdx != colInEdit)) &&
                      <Cell colIdx={colIdx} rowIdx={idx} col={col} linha={linha} type='readOnly' />}
                    {(col.editable && rowInEdit == linha.idx && colIdx == colInEdit && !col.currency) &&
                      <Cell colIdx={colIdx} rowIdx={idx} col={col} linha={linha} type='edit' />}
                  </React.Fragment>
                )}
              </div>
              <Collapse isOpen={linha.det.prod.collapse_lote}>
                <div className={'lotes-header-row'}>
                  <CabecalhoLotes idx={linha.idx}></CabecalhoLotes>
                </div>
                {Array.isArray(linha.det.prod.rastro) && linha.det.prod.rastro.map((lote, ixLote) =>
                  <LinhaLote linha={lote} idxLote={ixLote} key={`linha-lote-${ixLote}`}></LinhaLote>
                )}
                {linha.det.prod.rastro && !Array.isArray(linha.det.prod.rastro) &&
                  <LinhaLote linha={linha.det.prod.rastro} idxLote={0} idxProd={linha.idx}></LinhaLote>
                }
              </Collapse>
            </div>
          )
          }

        </div>
      </div>
    )
}

export default TableNfe;